// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Scrollbar customization */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #74b1be;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #5a8f9a;
}

/* Rest of the existing styles */
.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 15px;
  font-family: Arial, sans-serif;
  font-size: 14px;
}

/* Updated Titlebar styles */
.titlebar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background: #2f3241;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.titlebar-content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.window-title {
  color: #74b1be;
  font-size: 18px;
  font-weight: bold;
}

/* Adjust main content to account for titlebar */
.container {
  margin-top: 60px;
}

h1 {
  text-align: center;
  color: #333;
  margin-bottom: 20px;
  font-size: 1.6em;
}

.section {
  background-color: #f9f9f9;
  padding: 12px 15px;
  border-radius: 6px;
  margin-bottom: 15px;
  border: 1px solid #eee;
}

.section h2 {
  color: #444;
  font-size: 1.1em;
  margin-top: 0;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ddd;
}

.form-group {
  margin-bottom: 12px;
}

label {
  display: block;
  margin-bottom: 3px;
  color: #666;
  font-weight: 500;
  font-size: 0.9em;
}

input, textarea {
  width: 100%;
  padding: 6px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9em;
  box-sizing: border-box;
}

textarea {
  resize: vertical;
  min-height: 50px;
  font-family: Arial, sans-serif;
}

input:focus, textarea:focus {
  outline: none;
  border-color: #4CAF50;
  box-shadow: 0 0 5px rgba(76, 175, 80, 0.2);
}

.button-group {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

.button-group button {
  flex: 1;
  margin: 0;
}

button {
  width: 100%;
  padding: 8px;
  border: none;
  border-radius: 4px;
  font-size: 0.95em;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.primary-button {
  background-color: #4CAF50;
  color: white;
  margin-top: 15px;
}

.primary-button:hover {
  background-color: #45a049;
}

.primary-button:active {
  background-color: #3d8b40;
}

.secondary-button {
  background-color: #f0f0f0;
  color: #333;
  border: 1px solid #ddd;
}

.secondary-button:hover {
  background-color: #e4e4e4;
}

.secondary-button:active {
  background-color: #d8d8d8;
}

/* Date input specific styles */
input[type="date"] {
  padding: 5px 6px;
  font-family: Arial, sans-serif;
}

/* Number input specific styles */
input[type="number"] {
  padding-right: 0;
}

/* Cost Details styles */
.extra-costs-section {
  margin: 20px 0;
}

.extra-costs-header {
  margin-bottom: 10px;
}

.extra-costs-header h3 {
  margin: 0 0 10px 0;
}

.extra-costs-controls {
  display: flex;
  align-items: center;
  gap: 15px;
}

.add-cost-btn {
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
}

.add-cost-btn:hover {
  background-color: #45a049;
}

.extra-cost-item {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  align-items: center;
}

.extra-cost-title {
  flex: 2;
}

.extra-cost-amount {
  flex: 1;
}

.remove-cost-btn {
  background-color: #ff4444;
  color: white;
  border: none;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 18px;
  padding: 0;
}

.remove-cost-btn:hover {
  background-color: #cc0000;
}

/* Toggle Switch styles */
.toggle-switch {
  position: relative;
}

.toggle-switch label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}

.toggle-switch .slider {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
  background-color: #ccc;
  border-radius: 20px;
  transition: .4s;
}

.toggle-switch .slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  border-radius: 50%;
  transition: .4s;
}

.toggle-switch input:checked + .slider {
  background-color: #4CAF50;
}

.toggle-switch input:checked + .slider:before {
  transform: translateX(20px);
}

.toggle-switch .toggle-label {
  font-size: 0.9em;
  color: #666;
  white-space: nowrap;
}

/* Time input styles */
.time-input .time-fields {
  display: flex;
  gap: 10px;
  align-items: center;
}

.time-field {
  display: flex;
  align-items: center;
  gap: 5px;
}

.time-field input {
  width: 70px;
}

.time-field span {
  color: #666;
  font-size: 0.9em;
}

/* Toast styles */
.toast {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px 24px;
  border-radius: 4px;
  color: white;
  font-size: 14px;
  z-index: 1000;
  animation: slideUp 0.3s ease-out;
}

.toast.success {
  background-color: #4CAF50;
}

.toast.error {
  background-color: #f44336;
}

@keyframes slideUp {
  from {
    transform: translate(-50%, 100%);
    opacity: 0;
  }
  to {
    transform: translate(-50%, 0);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/renderer/App.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,gCAAgC;IAChC,UAAU;EACZ;EACA;IACE,6BAA6B;IAC7B,UAAU;EACZ;AACF","sourcesContent":["/* Scrollbar customization */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #74b1be;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #5a8f9a;\n}\n\n/* Rest of the existing styles */\n.container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 15px;\n  font-family: Arial, sans-serif;\n  font-size: 14px;\n}\n\n/* Updated Titlebar styles */\n.titlebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 50px;\n  background: #2f3241;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.titlebar-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.window-title {\n  color: #74b1be;\n  font-size: 18px;\n  font-weight: bold;\n}\n\n/* Adjust main content to account for titlebar */\n.container {\n  margin-top: 60px;\n}\n\nh1 {\n  text-align: center;\n  color: #333;\n  margin-bottom: 20px;\n  font-size: 1.6em;\n}\n\n.section {\n  background-color: #f9f9f9;\n  padding: 12px 15px;\n  border-radius: 6px;\n  margin-bottom: 15px;\n  border: 1px solid #eee;\n}\n\n.section h2 {\n  color: #444;\n  font-size: 1.1em;\n  margin-top: 0;\n  margin-bottom: 12px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #ddd;\n}\n\n.form-group {\n  margin-bottom: 12px;\n}\n\nlabel {\n  display: block;\n  margin-bottom: 3px;\n  color: #666;\n  font-weight: 500;\n  font-size: 0.9em;\n}\n\ninput, textarea {\n  width: 100%;\n  padding: 6px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.9em;\n  box-sizing: border-box;\n}\n\ntextarea {\n  resize: vertical;\n  min-height: 50px;\n  font-family: Arial, sans-serif;\n}\n\ninput:focus, textarea:focus {\n  outline: none;\n  border-color: #4CAF50;\n  box-shadow: 0 0 5px rgba(76, 175, 80, 0.2);\n}\n\n.button-group {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 15px;\n}\n\n.button-group button {\n  flex: 1;\n  margin: 0;\n}\n\nbutton {\n  width: 100%;\n  padding: 8px;\n  border: none;\n  border-radius: 4px;\n  font-size: 0.95em;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.primary-button {\n  background-color: #4CAF50;\n  color: white;\n  margin-top: 15px;\n}\n\n.primary-button:hover {\n  background-color: #45a049;\n}\n\n.primary-button:active {\n  background-color: #3d8b40;\n}\n\n.secondary-button {\n  background-color: #f0f0f0;\n  color: #333;\n  border: 1px solid #ddd;\n}\n\n.secondary-button:hover {\n  background-color: #e4e4e4;\n}\n\n.secondary-button:active {\n  background-color: #d8d8d8;\n}\n\n/* Date input specific styles */\ninput[type=\"date\"] {\n  padding: 5px 6px;\n  font-family: Arial, sans-serif;\n}\n\n/* Number input specific styles */\ninput[type=\"number\"] {\n  padding-right: 0;\n}\n\n/* Cost Details styles */\n.extra-costs-section {\n  margin: 20px 0;\n}\n\n.extra-costs-header {\n  margin-bottom: 10px;\n}\n\n.extra-costs-header h3 {\n  margin: 0 0 10px 0;\n}\n\n.extra-costs-controls {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.add-cost-btn {\n  background-color: #4CAF50;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.add-cost-btn:hover {\n  background-color: #45a049;\n}\n\n.extra-cost-item {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 10px;\n  align-items: center;\n}\n\n.extra-cost-title {\n  flex: 2;\n}\n\n.extra-cost-amount {\n  flex: 1;\n}\n\n.remove-cost-btn {\n  background-color: #ff4444;\n  color: white;\n  border: none;\n  width: 24px;\n  height: 24px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 18px;\n  padding: 0;\n}\n\n.remove-cost-btn:hover {\n  background-color: #cc0000;\n}\n\n/* Toggle Switch styles */\n.toggle-switch {\n  position: relative;\n}\n\n.toggle-switch label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n\n.toggle-switch .slider {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 20px;\n  background-color: #ccc;\n  border-radius: 20px;\n  transition: .4s;\n}\n\n.toggle-switch .slider:before {\n  position: absolute;\n  content: \"\";\n  height: 16px;\n  width: 16px;\n  left: 2px;\n  bottom: 2px;\n  background-color: white;\n  border-radius: 50%;\n  transition: .4s;\n}\n\n.toggle-switch input:checked + .slider {\n  background-color: #4CAF50;\n}\n\n.toggle-switch input:checked + .slider:before {\n  transform: translateX(20px);\n}\n\n.toggle-switch .toggle-label {\n  font-size: 0.9em;\n  color: #666;\n  white-space: nowrap;\n}\n\n/* Time input styles */\n.time-input .time-fields {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.time-field {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.time-field input {\n  width: 70px;\n}\n\n.time-field span {\n  color: #666;\n  font-size: 0.9em;\n}\n\n/* Toast styles */\n.toast {\n  position: fixed;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 12px 24px;\n  border-radius: 4px;\n  color: white;\n  font-size: 14px;\n  z-index: 1000;\n  animation: slideUp 0.3s ease-out;\n}\n\n.toast.success {\n  background-color: #4CAF50;\n}\n\n.toast.error {\n  background-color: #f44336;\n}\n\n@keyframes slideUp {\n  from {\n    transform: translate(-50%, 100%);\n    opacity: 0;\n  }\n  to {\n    transform: translate(-50%, 0);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
